import gdp from 'gio-webjs-sdk-cdp';
import { Env, hostNameToEnvMap } from '@/models/global';

interface GdpConfig {
  accountId: string;
  datasourceId: string;
  host: string;
}

const REPORT_HOST_TEST = 'collect-eu.test.xpeng.com';
const REPORT_HOST_PROD = 'collect-eu.xpeng.com';

const GDP_CONFIG_MAP: Partial<Record<Env, GdpConfig>> = {
  [Env.globalDeployTest]: {
    accountId: 'ad8f0b6eca5de78d',
    datasourceId: '8c185fa74f065481',
    host: REPORT_HOST_TEST
  },
  [Env.globalProd]: {
    accountId: '9bc4fa68f56ef629',
    datasourceId: 'ac6f13186f87ef55',
    host: REPORT_HOST_PROD
  }
};

function resolveConfig(): GdpConfig | null {
  const env = hostNameToEnvMap[window.location.hostname] as Env | undefined;
  if (!env) return null;
  const cfg = GDP_CONFIG_MAP[env];
  if (!cfg || !cfg.accountId || !cfg.datasourceId) return null;
  return cfg;
}

export function initGdp() {
  try {
    const cfg = resolveConfig();
    if (!cfg) return;
    gdp('init', cfg.accountId, cfg.datasourceId, {
      autotrack: true,
      host: cfg.host,
      version: '3.8',
      enableIdMapping: true
    });
    window.gdp = gdp as unknown as Window['gdp'];
  } catch (e) {
    console.error('initGdp error', e);
  }
}

export { gdp };
